import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import AppExternalPaymentSuccessView from 'src/views/AppExternalPaymentSuccess';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true,
    supportsDarkAndLightMode: true
  }
}));
export default AppExternalPaymentSuccessView;